import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Checkbox } from '@blueprintjs/core'

import ConfirmDialog from 'src/components/ConfirmDialog'
import {
    getAction,
    deleteAction,
    getSelectedActions,
} from 'src/store/modules/runbooks/actions'
import { getActiveRunbook } from 'src/store/modules/runbooks'
import {
    toggleControl,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'
import { pluralize } from 'src/utils/reducer'

import styles from './deleteActionDialog.module.scss'

class DeleteActionDialog extends React.Component {
    state = {
        deleteChildren: false,
    }

    handleCheckboxChange = (e) =>
        this.setState({ deleteChildren: e.target.checked })

    handleCancel = () => {
        const { singleEditAction, toggleControl } = this.props

        singleEditAction(null)
        toggleControl('isDeletingAction')
    }

    handleConfirm = () => {
        const { deleteAction, runbook, action, selectedActions } = this.props

        if (action) {
            deleteAction(runbook.id, action.uid, this.state.deleteChildren)
        } else {
            selectedActions.forEach((action) =>
                deleteAction(runbook.id, action, this.state.deleteChildren)
            )
        }

        this.handleCancel()
    }

    render() {
        const { deletingAlert, action, selectedActions } = this.props

        let dialogTitle = 'Are you sure you want to delete this action'
        if (!action) {
            dialogTitle = `Are you sure you want to delete this ${
                selectedActions.length <= 1 ? ' ' : selectedActions.length
            }
            ${pluralize('action', selectedActions)}?`
        }

        return (
            <ConfirmDialog
                title={dialogTitle}
                isOpen={deletingAlert}
                confirmLabel={`Delete ${pluralize('action', selectedActions)}`}
                confirmIntent="danger"
                onConfirm={this.handleConfirm}
                onCancel={this.handleCancel}
            >
                <Checkbox
                    checked={this.state.deleteChildren}
                    label="Delete children as well"
                    onChange={this.handleCheckboxChange}
                    className={styles.checkboxText}
                />
                <p className={styles.cautionText}>
                    Caution: this action cannot be undone.
                </p>
            </ConfirmDialog>
        )
    }
}

const mapStateToProps = (state) => {
    const runbook = getActiveRunbook(state)
    const action = getAction(
        state,
        runbook.id,
        state.ui.runbook.controls.singleOpenAction
    )
    return {
        runbook,
        action,
        selectedActions: getSelectedActions(state, runbook.id),
        deletingAlert: state.ui.runbook.controls.isDeletingAction,
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleControl,
            singleEditAction,
            deleteAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(DeleteActionDialog)
